import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductVariantDefinitionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllProductVariantDefinitions(page, size, search) {
    let queryParams = new URLSearchParams();
    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());
    if (search?.trim()) {
      queryParams.append('Search', search.trim());
    }
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ProductVariantDefinition,
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }

  async getByIdProductVariantDefinition(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ProductVariantDefinition,
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllProductVariantDefinition() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.ProductVariantDefinition,
      action: "GetAllProductVariant"
    });
    return await firstValueFrom(observable);
  }

  async createProductVariantDefinition(productVariantDefinition) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.ProductVariantDefinition,
    }, productVariantDefinition);
    return await firstValueFrom(observable);
  }

  async updateProductVariantDefinition(productVariantDefinition) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.ProductVariantDefinition,
    }, productVariantDefinition);
    return await firstValueFrom(observable);
  }

  async deleteProductVariantDefinition(id) {
    const observable: Observable<any> = this.httpClientService.delete({
      controller: ControllerType.ProductVariantDefinition,
    }, id);
    return await firstValueFrom(observable);
  }
}
